<template>
  <v-row no-gutters class="mb-5">
    <v-col cols="8" lg="9" class="d-lg-flex">
      <v-row no-gutters>
        <v-col cols="12" lg="6">
          <v-select
            :label="$t('message.common.website')"
            :items="sites"
            v-model="selected"
            return-object
            item-text="url"
            class="px-2"
            @input="setSelected"
          ></v-select>
        </v-col>
        <!-- <v-col cols="12" lg="6">
          <v-select
            :label="$t('message.common.appliance')"
            class="px-2"
            v-model="selectedDevice"
            :items="devices"
            :disabled="true"
            return-object
            item-text="name"
            @input="setSelectedDevice"
          ></v-select>
        </v-col> -->
      </v-row>
    </v-col>
    <v-col
      cols="4"
      lg="3"
      class="px-2 d-flex align-center justify-end align-self-start"
    >
      <slot></slot>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AnalyticsActionBar",
  props: {
    sites: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selected: this.sites[0],
      selectedDevice: "mobile"
      // devices: ["mobile", "desktop"]
    };
  },
  created() {
    this.emit();
  },
  methods: {
    setSelected(val) {
      this.selected = val;
      this.emit();
    },
    setSelectedDevice() {
      this.emit();
    },
    emit() {
      this.$emit("selected", {
        data: this.selected,
        device: this.selectedDevice
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.w-50 {
  width: 50%;
}
</style>
